import './App.css';
import SleepAnalysisDashboard from './components/SleepAnalysisDashboard';

function App() {
  return (
    <div className="App">
      <SleepAnalysisDashboard />
    </div>
  );
}

export default App;